/**
 * /admin/naver-requests — 네이버 연동 접수 큐 (담당자가 [요청 보냄] = 샵↔광고 계정 고정)
 *
 * 부모 `/admin` 라우트가 인증 가드와 `AdminLayout` 을 맡는다. UI 는 `NaverLinkRequestQueueSection`.
 * 설계: agent_docs/naver_ads_reporting_design.md §7.7
 */
import { createFileRoute } from '@tanstack/react-router'
import { NaverLinkRequestQueueSection } from '@/features/admin/NaverLinkRequestQueueSection'

export const Route = createFileRoute('/admin/naver-requests')({
  component: NaverLinkRequestQueueSection,
})
